"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DATE_FORMAT_SHORT = exports.DATE_FORMAT_ISO = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _momentTimezone = require("moment-timezone");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrapDaterangepicker = require("react-bootstrap-daterangepicker");

var _reactBootstrapDaterangepicker2 = _interopRequireDefault(_reactBootstrapDaterangepicker);

require("./DateRangeFilter.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DATE_FORMAT_ISO = exports.DATE_FORMAT_ISO = "YYYY-MM-DD";
var DATE_FORMAT_SHORT = exports.DATE_FORMAT_SHORT = "MM/DD/YY";

var getDefaultRanges = function getDefaultRanges() {
  return {
    "Current Week": [(0, _momentTimezone2.default)().startOf("week"), (0, _momentTimezone2.default)().endOf("week")],
    "Last Week": [(0, _momentTimezone2.default)().startOf("week").subtract(1, "week"), (0, _momentTimezone2.default)().endOf("week").subtract(1, "week")],
    "Current Month": [(0, _momentTimezone2.default)().startOf("month"), (0, _momentTimezone2.default)().endOf("month")],
    "Last Month": [(0, _momentTimezone2.default)().startOf("month").subtract(1, "month"), (0, _momentTimezone2.default)().endOf("month").subtract(1, "month")],
    "Current Year": [(0, _momentTimezone2.default)().startOf("year"), (0, _momentTimezone2.default)().endOf("year")],
    "Last Year": [(0, _momentTimezone2.default)().startOf("year").subtract(1, "year"), (0, _momentTimezone2.default)().endOf("year").subtract(1, "year")]
  };
};

var DateRangeFilter = (_temp2 = _class = function (_Component) {
  _inherits(DateRangeFilter, _Component);

  function DateRangeFilter() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DateRangeFilter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DateRangeFilter.__proto__ || Object.getPrototypeOf(DateRangeFilter)).call.apply(_ref, [this].concat(args))), _this), _this.handleApply = function (event, picker) {
      var _extends2;

      var mStartDate = picker.startDate,
          mEndDate = picker.endDate;

      var startDate = mStartDate ? mStartDate.format(DATE_FORMAT_ISO) : undefined;
      var endDate = mEndDate ? mEndDate.format(DATE_FORMAT_ISO) : undefined;

      var _this$context$locatio = _this.context.location,
          query = _this$context$locatio.query,
          pathname = _this$context$locatio.pathname;
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          param = _this$props.param,
          paramLower = _this$props.paramLower,
          paramUpper = _this$props.paramUpper;


      onChange({
        pathname: _this.props.to || pathname,
        query: _extends({}, query, (_extends2 = {}, _defineProperty(_extends2, paramLower || param + "_0", startDate), _defineProperty(_extends2, paramUpper || param + "_1", endDate), _extends2))
      });
    }, _this.handleCancel = function () {
      var _extends3;

      var _this$context$locatio2 = _this.context.location,
          query = _this$context$locatio2.query,
          pathname = _this$context$locatio2.pathname;
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          param = _this$props2.param,
          paramLower = _this$props2.paramLower,
          paramUpper = _this$props2.paramUpper;


      onChange({
        pathname: _this.props.to || pathname,
        query: _extends({}, query, (_extends3 = {}, _defineProperty(_extends3, paramLower || param + "_0", undefined), _defineProperty(_extends3, paramUpper || param + "_1", undefined), _extends3))
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DateRangeFilter, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          filterLabel = _props.children,
          className = _props.className,
          datePickerProps = _props.datePickerProps,
          valueLabel = _props.valueLabel;


      var rootClassName = (0, _classnames2.default)("erg-components-DateRangeFilter", "erg-font-sm", className);

      var label = valueLabel;

      var _DateRangeFilter$getC = DateRangeFilter.getCurrentValue(this.props, this.context),
          _DateRangeFilter$getC2 = _slicedToArray(_DateRangeFilter$getC, 2),
          start = _DateRangeFilter$getC2[0],
          end = _DateRangeFilter$getC2[1];

      if (start && end) {
        var startLabel = (0, _momentTimezone2.default)(start, DATE_FORMAT_ISO).format(DATE_FORMAT_SHORT);
        var endLabel = (0, _momentTimezone2.default)(end, DATE_FORMAT_ISO).format(DATE_FORMAT_SHORT);
        label = startLabel + " - " + endLabel;
      }

      return _react2.default.createElement(
        "div",
        { className: rootClassName },
        _react2.default.createElement(
          "label",
          { className: "erg-margin-right-5" },
          filterLabel,
          ":"
        ),
        _react2.default.createElement(
          _reactBootstrapDaterangepicker2.default,
          _extends({
            alwaysShowCalendars: true,
            endDate: end && (0, _momentTimezone2.default)(end, DATE_FORMAT_ISO),
            onApply: this.handleApply,
            onCancel: this.handleCancel,
            ranges: getDefaultRanges(),
            showCustomRangeLabel: false,
            startDate: start && (0, _momentTimezone2.default)(start, DATE_FORMAT_ISO)
          }, datePickerProps),
          _react2.default.createElement(
            "span",
            { className: "value" },
            label
          )
        )
      );
    }
  }], [{
    key: "getDefaultQuery",
    value: function getDefaultQuery(props) {
      var _ref2;

      var param = props.param,
          paramLower = props.paramLower,
          paramUpper = props.paramUpper;

      return _ref2 = {}, _defineProperty(_ref2, paramLower || param + "_0", undefined), _defineProperty(_ref2, paramUpper || param + "_1", undefined), _ref2;
    }
  }, {
    key: "getCurrentQuery",
    value: function getCurrentQuery(props, context) {
      var _ref3;

      var _DateRangeFilter$getC3 = DateRangeFilter.getCurrentValue(props, context),
          _DateRangeFilter$getC4 = _slicedToArray(_DateRangeFilter$getC3, 2),
          start = _DateRangeFilter$getC4[0],
          end = _DateRangeFilter$getC4[1];

      var param = props.param,
          paramLower = props.paramLower,
          paramUpper = props.paramUpper;

      return _ref3 = {}, _defineProperty(_ref3, paramLower || param + "_0", start), _defineProperty(_ref3, paramUpper || param + "_1", end), _ref3;
    }
  }, {
    key: "getCurrentValue",
    value: function getCurrentValue(props, context) {
      var query = context.location.query;
      var param = props.param,
          paramLower = props.paramLower,
          paramUpper = props.paramUpper;

      return [query[paramLower || param + "_0"], query[paramUpper || param + "_1"]];
    }
  }]);

  return DateRangeFilter;
}(_react.Component), _class.displayName = "DateRangeFilter", _class.contextTypes = {
  location: _propTypes2.default.object.isRequired
}, _class.defaultProps = {
  datePickerProps: {
    opens: "left"
  },
  valueLabel: "Select Date"
}, _class.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  datePickerProps: _propTypes2.default.object,
  onChange: _propTypes2.default.func,
  param: _propTypes2.default.string,
  paramLower: _propTypes2.default.string,
  paramUpper: _propTypes2.default.string,
  to: _propTypes2.default.string,
  valueLabel: _propTypes2.default.string
}, _temp2);
exports.default = DateRangeFilter;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/filters/DateRangeFilter.js
 ** module id = 791
 ** module chunks = 0
 **/